export const site = {
  name: "GP tax consulting s.r.o.",
  shortName: "GP tax consulting",
  tagline: "Daňové a účetní poradenství · Opava · od roku 1994",
  domain: "https://www.dane-a-ucetnictvi.eu",
  address: {
    street: "Sadová 121/4",
    postalCode: "746 01",
    city: "Opava",
    district: "Předměstí",
    full: "Sadová 121/4, 746 01 Opava – Předměstí",
  },
  ico: "01988875",
  dic: "CZ01988875",
  legalForm: "Společnost s ručením omezeným",
  register: "C 57058 vedená u Krajského soudu v Ostravě",
  registerShort: "C 57058, KS Ostrava",
  phone: "+420 553 612 851",
  phoneHref: "+420553612851",
  email: "info@dane-a-ucetnictvi.eu",
  web: "www.dane-a-ucetnictvi.eu",
  bank: "2400465455/2010",
  datovaSchranka: "59iy7m8",
  facebook: "https://www.facebook.com/dane.ucetnictvi.opava",
  hours: "8–14 hod",
  hoursSpec: "Po–Pá 8:00–14:00",
  since: 1994,
  practiceYears: 20,
  mapQuery: "Sadová 121/4, 746 01 Opava",
  mapEmbed:
    "https://www.google.com/maps?q=Sadov%C3%A1%20121%2F4%2C%20746%2001%20Opava&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=Sadov%C3%A1%20121%2F4%2C%20746%2001%20Opava",
} as const;

export const contactLines = [
  { label: "Telefon", value: site.phone, href: `tel:${site.phoneHref}` },
  { label: "E-mail", value: site.email, href: `mailto:${site.email}` },
  { label: "Pracovní doba", value: site.hours },
] as const;
